import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import footer_banner from '../../assets/images/footer_banner.png'
import defaultTexts from '../../texts/texts'

const Footer = () => {
  const jsDate = new Date()
  const currentYear = jsDate.getFullYear()

  const footer_height = 200

  const wrapperStyle = {
    minHeight: `${footer_height}px`,
    background: `url(${footer_banner}) no-repeat center / cover`,
    color: 'white',
    fontSize: '18px',
    padding: '0px 3%',
  }

  const contactLabel = {
    fontWeight: '500',
    paddingBottom: '20px',
  }

  const copyrightStyle = {
    width: '100%',
    height: `${footer_height * 0.25}px`,
    borderTop: 'white 1px solid',
    padding: '10px 0px',
  }

  const termsButtonStyle = {
    textTransform: 'capitalize',
    fontWeight: '400',
    color: 'white',
    fontSize: '18px',
    textDecoration: 'underline',

    '&:hover': {
      background: 'inherit',
      textDecoration: 'none',
    },
  }

  // const handleClickTermsOfUse = () => {
  //   window.open('#', '_blank')
  // }

  const handleClickPrivacyPolicy = () => {
    window.open('https://s3.grena.ge/flexostack/67122a81c4a5f8f11711206b/ui-docs/FlexoStack_Privacy_Policy.pdf', '_blank')
  }

  return (
    <Box sx={wrapperStyle} id='id_contact'>
      <Stack
        direction='row'
        alignItems='flex-start'
        justifyContent='space-between'
        sx={{
          width: '100%',
          height: `${footer_height * 0.75}px`,
          paddingTop: '20px',
        }}
      >
        <Box>
          {/* <Box>
            <Button
              variant='text'
              disableRipple
              disableElevation
              sx={termsButtonStyle}
              onClick={handleClickTermsOfUse}
            >
              {defaultTexts.termsOfUse}
            </Button>
          </Box> */}
          <Box>
            <Button
              variant='text'
              disableRipple
              disableElevation
              sx={termsButtonStyle}
              onClick={handleClickPrivacyPolicy}
            >
              {defaultTexts.privacyPolicy}
            </Button>
          </Box>
        </Box>
        <Box sx={{ textAlign: 'right', }}>
          <Box sx={contactLabel}>{defaultTexts.contact}</Box>
          <Box>{defaultTexts.contactPhoneText}</Box>
          <Box>{defaultTexts.contactEmailText}</Box>
        </Box>
      </Stack>

      <Box sx={copyrightStyle}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <Box>{defaultTexts.grena1999 + currentYear}</Box>
          <Box>{defaultTexts.allRightsReserved}</Box>
        </Stack>
      </Box>
    </Box>
  )
}

export default Footer